import { showError } from './utils';
import axios from 'axios';
import i18n from '../i18n';

export const API = axios.create({
  baseURL: process.env.REACT_APP_SERVER ? process.env.REACT_APP_SERVER : '',
});

API.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 403 && error.response?.data?.must_change_password) {
      window.location.href = '/user/edit';
      return;
    }
    showError(error);
  }
);
API.interceptors.request.use((config) => {
  config.headers['Accept-Language'] = i18n.language;
  return config;
});
